class ProductCardTemplate {
    constructor() {
      this.sectionSettings = [];
    }
  
    static newCardTemplate(product) {
      // section properties
      //media_size: section.settings.image_ratio, show_secondary_image: section.settings.show_secondary_image, add_image_padding: section.settings.add_image_padding, show_vendor: section.settings.show_vendor, show_image_outline: section.settings.show_image_outline
      const sectionSettings = document.querySelector("#sectionSettings") ? JSON.parse(document.querySelector("#sectionSettings").innerHTML) : {};
      const media_size = sectionSettings.image_ratio;
      const domain = `${Shopify.routes.root}`;
      const show_secondary_image = sectionSettings.show_secondary_image;
      const show_vendor = sectionSettings.show_vendor;
      this.sectionSettings = document.querySelector("#sectionSettings") ? JSON.parse(document.querySelector("#sectionSettings").innerHTML) : {};
      const filter_text = sectionSettings.filter_text;
      const isMarcy = product.title.includes('Marcy') ? 'marcy' : '';
      const isDrigg = (product.title.includes('Driggs') && product.title.includes('Classic')) ? 'driggs' : '';
  
      let productTitle = product.title; 
      
  
      if (product.tags.includes('multibundle')) {
        const titleArray = product.title.split(':');
        const titleArraySize = titleArray.length;
        if (titleArraySize > 0) {
          productTitle = titleArray[1];
        }
      }
  
      const cardHTML = `
        <product-card ${product.title.includes('Pack') ? 'class="hide-quick-atc"' : ''} data-selected-swatch="${product.handle}" data-json-script-id="${product.handle}-json">
          <script id="${product.handle}-json" type="application/json"></script>
          <div class="card-wrapper" itemprop="itemListElement" itemscope itemtype="https://schema.org/Product">
            <meta itemprop="url" content="${domain}products/${product.handle}">
            <div class="card-image-wrapper">
              <div class="items-badges ${isMarcy} ${isDrigg}">
                ${this.updateProductStockBadges(product)}
              </div>
              <a href="${domain}products/${product.handle}" class="full-unstyled-link">
                <span class="visually-hidden">${product.title}</span>
                <div class="card card--product card--outline" tabindex="-1">
                  <div class="card__inner">
                    <div>
                      <div class="carousel-container">
                        ${this.generateMobileCarousel(product)}
                      </div>
                    </div>
                    <div class="card__badge"></div>
                  </div>
                </div>
              </a>
              ${this.sectionSettings?.reviews_below_image ? `<div class="card-rating-badge" data-product-id="${product.id}"></div>` : ""}
              ${this.quickAddTemplate(product.options, product.handle)}
            </div>
            <div class="card-infos">
              <div class="card-information">
                <div class="card-information__wrapper">
                <a class="" href="${domain}products/${product.handle}">
                  <h2 class="card-information__text h5">
  
  
                    ${productTitle}
                  </h2>
                </a>
                  ${this.priceInformation(product)}
                </div>
              </div>
              ${this.colorSwatchTemplate(product.options, product.tags, product.handle, product.redirects)}
              ${this.mobileQuickAddTemplate(product.options, product.handle)}
            </div>
          </div>
        </product-card>
      `;
  
      const handleParts = product.handle.split('-');
      const shortHandle = handleParts[0] + '-' + handleParts[1];
      const cardClass = `card-${shortHandle}`;
      
      return `<li class="grid__item ${cardClass} ${product.product_type === 'Womens-tees' && product.title.includes('9-Pack') ? 'womens-tees-9pack' : ''}">${cardHTML}</li>`;
    }
  
    static updateProductStockBadges(product) {
      let badges = [];
      let badgeSpans = "";
      let tags = product.tags;
      // products.json (used by the filter re-render path) has no top-level `available`
      // field, unlike products/{handle}.js — derive it from variants.
      var isAvailable = product.available !== undefined ? product.available : product.variants.some((variant) => variant.available);
      var priceVariant = product.variants.find((variant) => variant.available) || product.variants[0];
      var price = parseFloat(priceVariant.price);
      var compare_at_price = parseFloat(priceVariant.compare_at_price);
      var isFinalSale = tags.includes('final-sale');

      if (isAvailable == false) {
        badges.push("Sold out_sold-out");
      } else if (isFinalSale) {
        // Final Sale takes priority over every other tag-based badge (low stock, pack, best seller, new, sale, etc.)
        badges.push("Final Sale_final-sale");
      } else {
        if (tags.includes('low_stock')) {
          badges.push("Selling Out_low-stock");
        }
        tags.forEach((tag) => {
          if (badges.length < 1) {
            if (tag.includes("pack_each_") && Shopify.country == 'US') {
              let badge = "$" + tag.replace("pack_each_", "") + " each_each";
              badges.push(badge);
            }
            else if (tag === "BestSellers") {
              let tagWithoutBadge = "BEST SELLER_best-seller";
              badges.push(tagWithoutBadge);
            }
            else if (tag === "multibundle") {
              let tagWithoutBadge = "BUNDLE PRICE_multibundle";
              badges.push(tagWithoutBadge);
            }
            else if (tag.includes("badge_") && Shopify.country == 'US') {
              let tagWithoutBadge = tag.replace("badge_", "") + "_underwear-badge";
              badges.push(tagWithoutBadge);
            }
            else if (tag.includes("pack_discount_")) {
              let tagWithoutBadge = tag.replace("pack_discount_", "") + " % off_pack-discount";
              badges.push(tagWithoutBadge);
            }
            else if (tag === "new_stock") {
              let badge = "new_new";
              badges.push(badge);
            }
            else if (tag.includes("labelpack_")) {
              let badge = tag.replace("labelpack_", "").toUpperCase() + "_labelpack";
              badges.push(badge);
            }
            else if (tag.includes("labelpack2_")) {
              let badge = tag.replace("labelpack2_", "").toUpperCase() + "_labelpack2";
              badges.push(badge);
            }
            else if (tag.includes("customtag_")) {
              let badge = tag.replace("customtag_", "") + "_customtag";
              badges.push(badge);
            }
          }
        });

        if (compare_at_price > price) {
          const titleLower = product.title.toLowerCase();
          const handleLower = product.handle.toLowerCase();
          if (!titleLower.includes('pre order') && !titleLower.includes('pre-order') && !titleLower.includes('preorder') && !titleLower.includes('pack') && !handleLower.includes('multibundle')) {
            badges.push("Sale_sale");
          }
        }
      }

      if (tags.includes('multibundle')) {
        const bundleBadge = "BUNDLE PRICE_multibundle";
        const mixAndMatchBadge = "Mix & Match-FFFFFF-777057_customtag";
        if (!badges.includes(bundleBadge)) badges.push(bundleBadge);
        if (!badges.includes(mixAndMatchBadge)) badges.push(mixAndMatchBadge);
      }

      badges.forEach((badge) => {
        var item = badge.split('_');
        if (item.length > 1) {
          if (item[1] === 'customtag') {
            var customParts = item[0].split('-');
            var customText = customParts[0] || '';
            var customColor = customParts[1] || 'FFFFFF';
            var customBg = customParts[2] || '000000';
            badgeSpans += `<span class="badge-item badge-customtag" style="color: #${customColor}; background-color: #${customBg};">${customText}</span>`;
          } else {
            badgeSpans += `<span class="badge-item badge-${item[1]
              .replace(/\s+/g, "-")
              .toLowerCase()}">${item[0]}</span>`; 
          }
        }
      });
      return badgeSpans;
    }
  
    static quickAddTemplate(options, prodHandle) {
      const quickAddText = this.sectionSettings ? this.sectionSettings.add_button_text: 'Quick Add';
      const includesColor = options.find((option) => option.name === "Color" || option.name === "Couleur");
      const quickHTML = includesColor ? `
        <quick-add data-selected-swatch="${prodHandle}">
          <div class="quick-add-btn">
            + ${quickAddText}
            <div class="quick-add-options__wrapper">
              ${options.map((option) => {
                return option.name !== "Color" && option.name !== "Couleur" ? `
                  <div class="quick-add-option">
                    <div class="quick-add-option-name">${option.name}:</div>
                    <div data-option-position="option${option.position}" data-option-name="${option.name}" class="quick-add-option-values">
                      ${option.values.map(value => {
                        return `<span class="quick-add-option-value">${value}</span>`
                      }).join("")}
                    </div>
                  </div>
                `: "";
              }).join("")}
            </div>
          </div>
        </quick-add>
      `: "";
  
      return quickHTML;
    }
  
    static priceInformation(product) {
      const productColor = product.options.find((option) => option.name === "Color" || option.name === "Couleur");
      const hasColorOption = productColor ? true : false;
      const color = productColor ? productColor.values[0] : null;
      const from_text = product.handle.includes('multibundle') ? 'From: ': '';
      let formattedTags = product.tags.map(tag => tag.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
      let multibundleTag = formattedTags.find(tag => tag.includes('multibundle-save-'));
      var off_text = '';
  
      var compare_at_price, price;
      product.variants.forEach(variant => {
        var variantComparePrice = parseFloat(variant.compare_at_price);
        var variantPrice = parseFloat(variant.price);
  
        if(!compare_at_price || (variantComparePrice && variantComparePrice < compare_at_price)) {
          compare_at_price = variantComparePrice;
        }
        if(!price || (variantPrice && variantPrice < price)) {
          price = variantPrice;
        }
      });
     
      
      if (multibundleTag) {
        const tagParts = multibundleTag.split('multibundle-save-');
        
        if (tagParts.length > 1) {
            let number = parseInt(tagParts[1], 10);
  
            off_text = `${number}% Off`;
            if (price >= 150) {
               // off_text += ` + Free Shipping`;
            }
        } 
    }
      const prodAvailable = product.variants.find((variant) => variant.available === true) ? true : false;
      const isFinalSale = product.tags.includes('final-sale');

      const priceHTML = `
        <div class="price
          ${prodAvailable === false ? " price--sold-out" : ""}
          ${compare_at_price > price ? " price--on-sale" : ""}
          ${compare_at_price > price && isFinalSale ? " price--final-sale" : ""}">
          <dl>
            <div class="price__regular">
              <dt>
                <span class="visually-hidden visually-hidden--inline">Regular Price</span>
              </dt>
              <dd>
                <span class="price-item price-item--regular
                  ${hasColorOption && color ? " border-right" : ""} product-card-price">
                  ${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(price)} ${window.theme.shop_currency}
                </span>
                ${hasColorOption && color ? `<span class="product-color">${color.split('+').join(', ')}</span>`: ""}
              </dd>
            </div>
            <div class="price__sale">
              <dd class="price__compare product-card">
                <s class="price-item product-card price-item--sale">
                  ${window.theme.cart_currency_symbol} ${compare_at_price} ${window.theme.shop_currency}
                  ${hasColorOption && color ? `
                     | <span class="product-color">${color.split('+').join(', ')}</span>
                  `: ""}
                </s>
              </dd>
              <dt>
                <span class="visually-hidden visually-hidden--inline">Sale Price</span>
              </dt>
              <dd class="price__compare">
                <span class="mb-from-text">${from_text}&nbsp;</span>
                <span class="price-item product-card price-item--sale">
                  ${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(price)} ${window.theme.shop_currency}
                </span>
                <span class="price-item old-price">
                  ${window.theme.cart_currency_symbol}  ${compare_at_price} ${window.theme.shop_currency}
                </span>
                ${hasColorOption && color ? `
                  <span class="product-color">${color.split('+').join(', ')}</span>
                `: ""}
              </dd>
            </div>
          </dl>
        </div>
        `;
          // ${multibundleTag ? `<span class="multibundle-badge">${off_text}</span>`: ''}
  
      return priceHTML;
    }
  
    static colorSwatchTemplate(options, tags, prodHandle, redirects = null) {
      const includesColor = options.find((option) => option.name === "Color" || option.name === "Couleur");
      if (includesColor) {
        var prod_color = (tags.find(tag => tag.startsWith("color_")) || "").replace("color_", "");
      }
      const swatchHTML = includesColor ? `
        <product-swatch>
          <div class="product-swatches">
            <div data-color="${includesColor.values[0]}" data-handle="${prodHandle}" data-url="" class="product-swatch swatch-selected">
              <span class="swatch-color ${this.handleize(prod_color)}"></span> 
            </div>
            ${tags.map(tag => {
              if(tag.includes("related_")) {
                const handleAndColorArr = tag.split("related_")[1].split(":");
                const varHandle = handleAndColorArr[0];
                const varColor = handleAndColorArr[1];
                var url_redirect = "";
                if (window.excluded_handles && Array.isArray(window.excluded_handles) && window.excluded_handles.includes(varHandle)) {
                  return "";
                }
                if (redirects && redirects.length > 0) {
                  url_redirect = (redirects.find(item => item.id === varHandle) || {}).url || "";
                }
                return `
                  <div data-color="${varColor.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}" data-handle="${varHandle}" class="product-swatch" data-url="${url_redirect}">
                    <span type="radio" class="swatch-color ${this.handleize(varColor)}"></span>
                  </div>
                `;
              } else {return ""}
            }).join("")}
          </div>
        </product-swatch>
      `: "";
  
      return swatchHTML;
    }
  
    static mobileQuickAddTemplate(options, prodHandle) {
      const quickAddText = this.sectionSettings ? this.sectionSettings.add_button_text: 'Quick Add';
      const includesColor = options.find((option) => option.name === "Color" || option.name === "Couleur");
      const quickaddHTML = includesColor ? `
        <mobile-quick-add data-selected-swatch="${prodHandle}">
          <div class="mobile-quick-add-options__wrapper">
            ${options.map(option => {
              return option.name !== "Color" && option.name !== "Couleur" ? `
                <div class="quick-add-option">
                  <div class="quick-add-option-name">${option.name}:</div>
                  <div data-option-name="${option.name}" data-option-position="option${option.position}" class="quick-add-option-values">
                    ${option.values.map(value => {
                      return `<span class="quick-add-option-value">${value}</span>`
                    }).join("")}
                  </div>
                </div>
              `: "";
            }).join("")}
          </div>
          <button type="button" class="mobile-quick-add-btn">
          ${quickAddText}
          </button>
        </mobile-quick-add>
      `: "";
  
      return quickaddHTML;
    }

    static generateMobileCarousel(product) {
      const maxImages = 6;
      const productImages = Array.isArray(product.images) ? product.images.filter((_, index) => index < maxImages) : [];
      const imageCount = productImages.length;
      const show_secondary_image = this.sectionSettings ? this.sectionSettings.show_secondary_image : false;
      
      if (imageCount === 0) return '';
      
      const slidesHTML = productImages.map((image, index) => {
        const isFirst = index === 0;
        const loading = isFirst ? 'eager' : 'lazy';
        const src = isFirst ? image.src : '';
        const dataSrc = isFirst ? '' : image.src;
        
        return `
          <div class="mobile-carousel-slide">
            <div class="media media--transparent media--adapt" style="padding-bottom: 133%;">
              <img
                srcset="${image.src}?width=165 165w, ${image.src}?width=360 360w, ${image.src}?width=533 533w, ${image.src}?width=720 720w, ${image.src}?width=940 940w, ${image.src}?width=1066 1066w"
                src="${src}"
                ${dataSrc ? `data-src="${dataSrc}"` : ''}
                sizes="(min-width: 1200px) calc((100vw - 130px) / 4), (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                alt="${product.title} ${product.options?.find(opt => opt.name === 'Color' || opt.name === 'Couleur')?.values?.[0] || ''} ${product.tags?.join(',')?.split('fit_')?.pop()?.split(',')?.[0] || ''} ${product.product_type?.split('-')?.pop() || ''}"
                loading="${loading}"
                class="motion-reduce"
                width="${image.width}"
                height="${image.height}"
              >
            </div>
          </div>
        `;
      }).join('');

      const navigationHTML = imageCount > 3 ? `
        <button class="mobile-carousel-nav prev" aria-label="Previous image">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
          </svg>
        </button>
        <button class="mobile-carousel-nav next" aria-label="Next image">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </button>
        <div class="mobile-carousel-pagination">
          ${productImages.map((_, index) => 
            `<div class="mobile-carousel-dot ${index === 0 ? 'active' : ''}" data-slide="${index}"></div>`
          ).join('')}
        </div>
      ` : '';

      const hoverImageHTML = product.images[1] && show_secondary_image ? `
        <div class="carousel-hover-overlay">
          <img
            srcset="${product.images[1].src}?width=165 165w, ${product.images[1].src}?width=360 360w, ${product.images[1].src}?width=533 533w, ${product.images[1].src}?width=720 720w, ${product.images[1].src}?width=940 940w, ${product.images[1].src}?width=1066 1066w"
            src="${product.images[1].src}"
            sizes="(min-width: 1200px) calc((100vw - 130px) / 4), (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
            alt="${product.title} ${product.options?.find(opt => opt.name === 'Color' || opt.name === 'Couleur')?.values?.[0] || ''} ${product.tags?.join(',')?.split('fit_')?.pop()?.split(',')?.[0] || ''} ${product.product_type?.split('-')?.pop() || ''}"
            loading="lazy"
            class="motion-reduce carousel-hover-image"
            width="${product.images[1].width}"
            height="${product.images[1].height}"
          >
        </div>
      ` : '';

      return `
        <mobile-image-carousel class="mobile-image-carousel ${imageCount <= 2 ? 'no-navigation' : ''}" 
             data-product-handle="${product.handle}"
             data-image-count="${imageCount}">
          <div class="mobile-carousel-wrapper">
            ${slidesHTML}
          </div>
          ${navigationHTML}
          ${hoverImageHTML}
        </mobile-image-carousel>
      `;
    }
  
    /* from https://gist.github.com/tyteen4a03/3420a9e121d13b091343 */
    static handleize(str) {
      str = str.toLowerCase();
  
      var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  
      // For the old browsers
      for (var i = 0; i < toReplace.length; ++i) {
          str = str.replace(toReplace[i], "");
      }
  
      str = str.replace(/\W+/g, "-");
  
      if (str.charAt(str.length - 1) == "-") {
          str = str.replace(/-+\z/, "");
      }
  
      if (str.charAt(0) == "-") {
          str = str.replace(/\A-+/, "");
      }
  
      return str
    }
  }